import styled from 'styled-components';

// Page-level form wrapper for the Salary Structure onboarding step.
export const StyledForm = styled.form`
  width: 100%;
`;
